import _ from 'lodash';
import { TextBoxField } from 'app-ui-componentlibrary';
import React, { useEffect, useState } from 'react';
import { Button, Card, Divider, Dropdown, Form, Grid, Icon, Loader, Message, Label } from 'semantic-ui-react';

const SignatureTitleForm = ({
    signatureTitleInfo,
    needSignature,
    signatureFileType,
    setSignatureFileType,
    signatureBase64Data,
    setSignatureBase64Data,
    title1,
    title2,
    setTitle1,
    setTitle2
}) => {
    const [signatureTouched, setSignatureTouched] = useState(false);
    const [title1Touched, setTitle1Touched] = useState(false);
    const [title2Touched, setTitle2Touched] = useState(false);

    useEffect(() => {
        setTitle1Touched(false);
        setTitle2Touched(false);
        setSignatureTouched(false);
    }, [_.get(signatureTitleInfo, 'emailAdr')]);

    const signatureFileChangeHandler = async (e) => {
        const file = e.target.files[0];
        const dataUrl = await loadDataUrl(file);
        const base64Data = _.nth(_.split(dataUrl, ","), 1);
        const fileType = file.type;
        const femaFileType = _.isEqual(fileType, "image/jpeg") ? "JPG" : _.isEqual(fileType, "image/png") ? "PNG" : null;
        setSignatureTouched(true);
        setSignatureFileType(femaFileType);
        setSignatureBase64Data(base64Data);
    }

    const loadDataUrl = async (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.readAsDataURL(file)
        });
    }

    const validateTitle = (titleValue) => {
        if (_.isEmpty(titleValue)) {
            return "This field is required.";
        }
        if (_.size(titleValue) > 200) {
            return "Your response must be less than or equal to 200 characters.";
        }
        return '';
    }


    const displayCurrentSignature = () => {
        const imgSrc = (signatureBase64Data && signatureFileType) ? `data:image/${signatureFileType};base64,${signatureBase64Data}` : null;
        return (
            <Form.Field>
                <strong>Current signature file</strong>
                {imgSrc ? <img class="ui medium image" src={imgSrc} /> : <p>(None)</p>}
            </Form.Field>
        )
    }

    return (
        <>
            {displayCurrentSignature()}
            <Form.Field>

                <label htmlFor="signatureFile"><strong>Signature file {!needSignature && "(optional)"}</strong></label>
                <input type="file" id="signatureFile" name="signatureFile" accept="image/png, image/jpeg" onChange={async (e) => signatureFileChangeHandler(e)}
                    onBlur={() => setSignatureTouched(true)}
                />
                {(signatureTouched && needSignature && (!signatureBase64Data || !signatureFileType)) &&
                    <Label
                        color="red"
                        basic
                        pointing="above"
                    >
                        This field is required.
                    </Label>
                }
            </Form.Field>
            <TextBoxField
                size="30"
                maxlength="200"
                label="Title line 1"
                aria-label="Title line 1"
                name="title1"
                title="Title line 1"
                handleChange={(e) => {
                    e.preventDefault();
                    setTitle1(e.target.value);
                    setTitle1Touched(true)
                }}
                handleBlur={() => setTitle1Touched(true)}
                value={title1}
                errorMessages={validateTitle(title1)}
                displayError={title1Touched && validateTitle(title1)}
            />
            <TextBoxField
                size="30"
                maxlength="200"
                label="Title line 2"
                name="title2"
                title="Title line 2"
                handleChange={(e) => {
                    e.preventDefault();
                    setTitle2(e.target.value);
                    setTitle2Touched(true)
                }}
                handleBlur={() => setTitle2Touched(true)}
                value={title2}
                errorMessages={validateTitle(title2)}
                displayError={title2Touched && validateTitle(title2)}
            />
        </>
    )
}

export default SignatureTitleForm;